/* Match the main product photograph to the selected color, even before size is chosen. */
(() => {
  const form = document.querySelector('form[data-product-form]');
  const main = document.getElementById('MainProductImage');
  if (!form || !main) return;
  const variants = (() => { try { return JSON.parse(form.dataset.variants || '[]'); } catch { return []; } })();
  const selectors = [...form.querySelectorAll('[data-variant-option]')];
  const colorIndex = selectors.findIndex(s => /^(color|colour|colors|colours)$/i.test((s.getAttribute('aria-label') || '').trim()));
  if (colorIndex < 0) return;
  const imageSrc = (image) => typeof image === 'string' ? image : image?.src || '';
  const normalize = url => (url || '').replace(/^https?:/, '').split('?')[0].replace(/_(?:\d+x\d*|\d*x\d+)(?=\.)/, '');
  const sync = () => {
    const color = selectors[colorIndex].value;
    if (!color) return;
    const matches = variants.filter(v => v.options?.[colorIndex] === color);
    const selected = matches.find(v => v.available && v.featured_image) || matches.find(v => v.featured_image);
    let url = imageSrc(selected?.featured_image);
    if (!url) {
      const thumbs = [...document.querySelectorAll('.da-product-layout [data-gallery-image]')];
      const match = thumbs.find(t => (t.querySelector('img')?.alt || '').toLowerCase().includes(color.toLowerCase()));
      url = match?.dataset.galleryImage || '';
    }
    if (!url) return;
    main.src = url;
    const thumbs = [...document.querySelectorAll('.da-product-layout [data-gallery-image]')];
    thumbs.forEach(t => t.classList.toggle('is-active', normalize(t.dataset.galleryImage) === normalize(url)));
  };
  form.addEventListener('change', e => {
    if (e.target.matches('[data-variant-option]')) queueMicrotask(sync);
  });
})();
